import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

const VIEWPORT = { once: true, margin: "-60px" };
const HIDDEN = { opacity: 0 };
const VISIBLE = { opacity: 1, y: 0 };

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ ...HIDDEN, y }}
    whileInView={VISIBLE}
    viewport={VIEWPORT}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p className={`uppercase tracking-[0.25em] text-xs font-medium ${light ? "text-[#D39A2E]" : "text-[#2852A6]"}`}>
    {children}
  </p>
);
